import React from 'react';
import PropTypes from 'prop-types';
import CodeEditor from './CodeEditor';
import EditorTab from './EditorTab';
import Breadcrumbs from './Breadcrumbs';
import { Alert, Button } from 'reactstrap';
import EditorFileActions from './EditorFileActions';

const CodeEditorPanel = ({
  editorValue,
  imagePreviewUrl,
  isDirty,
  isFileLoading,
  onCloseTab,
  onEditorChange,
  onReloadFile,
  onSave,
  onSelectFile,
  openTabs,
  selectedPath,
  showConflict,
  saveErrorMessage,
}) => {
  return (
    <>
      <div className="vibe-code-editor-panel d-flex flex-column flex-grow-1 overflow-hidden h-100 min-w-0">
        <div className="vibe-editor-tabs d-flex align-items-center border-bottom">
          <div className="vibe-editor-tabs__list d-flex align-items-center flex-grow-1 overflow-auto min-w-0">
            <EditorTab
              openTabs={openTabs}
              selectedPath={selectedPath}
              isDirty={isDirty}
              onSelectFile={onSelectFile}
              onCloseTab={onCloseTab}
            />
          </div>
          <EditorFileActions
            editorValue={editorValue}
            selectedPath={selectedPath}
            isFileLoading={isFileLoading}
          />
        </div>
        <Breadcrumbs selectedPath={selectedPath} />
        {showConflict ? (
          <Alert
            color="warning"
            className="mb-0 rounded-0 py-2 px-3 d-flex align-items-center justify-content-between"
          >
            <span>Remote changes detected.</span>
            <Button color="warning" size="sm" outline onClick={onReloadFile}>
              Reload from disk
            </Button>
          </Alert>
        ) : null}

        {!showConflict && saveErrorMessage ? (
          <Alert color="danger" className="mb-0 rounded-0 py-2 px-3">
            Could not save file: {saveErrorMessage}. Edits are still in the editor — retry Save.
          </Alert>
        ) : null}

        <div className="vibe-code-editor-panel__editor flex-grow-1 overflow-hidden min-h-0">
          <CodeEditor
            editorValue={editorValue}
            imagePreviewUrl={imagePreviewUrl}
            selectedPath={selectedPath}
            isFileLoading={isFileLoading}
            onEditorChange={onEditorChange}
            onSave={onSave}
          />
        </div>
      </div>
    </>
  );
};

CodeEditorPanel.propTypes = {
  editorValue: PropTypes.string.isRequired,
  imagePreviewUrl: PropTypes.string,
  files: PropTypes.object.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isFileLoading: PropTypes.bool.isRequired,
  onCloseTab: PropTypes.func.isRequired,
  onEditorChange: PropTypes.func.isRequired,
  onReloadFile: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onSelectFile: PropTypes.func.isRequired,
  openTabs: PropTypes.array.isRequired,
  selectedPath: PropTypes.string.isRequired,
  showConflict: PropTypes.bool.isRequired,
  saveErrorMessage: PropTypes.string,
};

CodeEditorPanel.defaultProps = {
  imagePreviewUrl: '',
  saveErrorMessage: '',
};

export default CodeEditorPanel;
